export default "__VITE_ASSET__H45awpYf__"